const topicsData = [
    {
      topic: "Spiritual",
      subtopics: [
        { label: "Spiritual", link: "/spiritual" },
        { label: "Meditation", link: "/spiritual/meditation" },
        { label: "Nature", link: "/spiritual/nature" },
        { label: "Gratitude", link: "/spiritual/gratitude" },
      ],
    },
    {
      topic: "Physical",
      subtopics: [
        { label: "Physical", link: "/physical" },
        { label: "Exercise", link: "/physical/exercise" },
        { label: "Cardio", link: "/exercise/cardio" },
        { label: "Strength", link: "/exercise/strength" },
        { label: "Flexibility", link: "/exercise/flexibility" },
        { label: "Nutrition", link: "/physical/nutrition" },
        { label: "Hydration", link: "/physical/hydration" },
        { label: "Intermittent Fasting", link: "/physical/fasting" },
        { label: "Balanced Diet", link: "/physical/diet" },
        { label: "Sleep", link: "/physical/sleep" },
      ],
    },
    {
      topic: "Intellectual",
      subtopics: [
        { label: "Intellectual", link: "/intellectual" },
        { label: "Lifelong Learning", link: "/intellectual/lifelonglearning" },
        { label: "Reading", link: "/intellectual/reading" },
        { label: "Learning Languages", link: "/intellectual/language" },
        { label: "Brain Games", link: "/intellectual/braingames" },
      ],
    },
    {
      topic: "Relational",
      subtopics: [
        { label: "Relational", link: "/relational" },
        { label: "Relationships", link: "/relational/relationships" },
        { label: "Communication", link: "/relational/communication" },
        { label: "Active Listening", link: "/relational/listening" },
        { label: "Speaking", link: "/relational/speaking" },
        { label: "Conflict Resolution", link: "/relational/conflictresolution" },
      ],
    },
    {
      topic: "Emotional",
      subtopics: [
        { label: "Emotional", link: "/emotional" },
        { label: "Stress Management", link: "/emotional/stress" },
        { label: "Emotional Resilience", link: "/emotional/resilience" },
        { label: "Emotional Intelligence", link: "/emotional/emotionalintelligence" },
      ],
    },
    {
        topic: "Habits",
        subtopics: [
          { label: "Habits", link: "/habits" },
          { label: "Habits: The Basics", link: "/habits/basics" },
        ],
      }
];

export default topicsData;
